export const categories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-apps-2-line" },
  { id: "love", name: "恋爱", slug: "love", icon: "ri-heart-line" },
  { id: "action", name: "热血", slug: "action", icon: "ri-fire-line" },
  { id: "fantasy", name: "奇幻", slug: "fantasy", icon: "ri-magic-line" },
  { id: "comedy", name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line" },
  { id: "horror", name: "悬疑", slug: "horror", icon: "ri-ghost-line" },
  { id: "school", name: "校园", slug: "school", icon: "ri-book-open-line" },
  { id: "urban", name: "都市", slug: "urban", icon: "ri-building-line" },
  { id: "history", name: "古风", slug: "history", icon: "ri-archive-line" },
  { id: "scifi", name: "科幻", slug: "scifi", icon: "ri-rocket-line" },
];

export const comics = [
  {
    id: 1,
    title: "总裁的秘密恋人",
    author: "墨染青衣",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20romantic%20couple%20in%20modern%20urban%20setting%2C%20soft%20warm%20lighting%2C%20elegant%20art%20style%2C%20watercolor%20texture%2C%20gentle%20pink%20and%20peach%20tones%2C%20clean%20simple%20background%20with%20subtle%20floral%20elements%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    category: "love",
    description: "她是平凡的小职员，他是高高在上的集团总裁。一次意外邂逅，让两个世界的人命运交织。当秘密被揭开，爱情能否跨越身份的鸿沟？甜蜜又虐心的都市恋爱故事，带你感受心动瞬间。",
    rating: 9.5,
    views: 1280000,
    status: "连载中",
    updateTime: "2026-08-04",
    chapters: [
      { id: 1, title: "第1话 意外相遇", updateTime: "2026-07-01" },
      { id: 2, title: "第2话 心跳加速", updateTime: "2026-07-04" },
      { id: 3, title: "第3话 他的温柔", updateTime: "2026-07-08" },
      { id: 4, title: "第4话 秘密揭晓", updateTime: "2026-07-12" },
      { id: 5, title: "第5话 命运抉择", updateTime: "2026-07-16" },
      { id: 6, title: "第6话 心动告白", updateTime: "2026-07-20" },
      { id: 7, title: "第7话 甜蜜危机", updateTime: "2026-07-24" },
      { id: 8, title: "第8话 勇敢的心", updateTime: "2026-07-28" },
      { id: 9, title: "第9话 深情相拥", updateTime: "2026-08-01" },
      { id: 10, title: "第10话 永恒誓约", updateTime: "2026-08-04" },
    ],
    tags: ["恋爱", "都市", "总裁", "甜宠"],
  },
  {
    id: 2,
    title: "武道巅峰",
    author: "疾风剑豪",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20showing%20a%20martial%20arts%20warrior%20in%20action%20pose%20with%20flowing%20robes%2C%20dramatic%20wind%20effects%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20ancient%20Chinese%20fantasy%20aesthetic%2C%20clean%20minimal%20background%2C%20vertical%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    category: "action",
    description: "少年林风自幼体质羸弱，被家族视为废材。偶得神秘武道传承，从此踏上逆天改命之路。历经磨难，百炼成钢，终成一代武道至尊！热血沸腾的战斗场面，跌宕起伏的剧情发展。",
    rating: 9.7,
    views: 2560000,
    status: "连载中",
    updateTime: "2026-08-03",
    chapters: [
      { id: 1, title: "第1话 废材少年", updateTime: "2026-06-15" },
      { id: 2, title: "第2话 奇遇", updateTime: "2026-06-19" },
      { id: 3, title: "第3话 突破", updateTime: "2026-06-23" },
      { id: 4, title: "第4话 初露锋芒", updateTime: "2026-06-27" },
      { id: 5, title: "第5话 宗门大比", updateTime: "2026-07-01" },
      { id: 6, title: "第6话 一战成名", updateTime: "2026-07-06" },
      { id: 7, title: "第7话 秘境探险", updateTime: "2026-07-11" },
      { id: 8, title: "第8话 生死之战", updateTime: "2026-07-16" },
      { id: 9, title: "第9话 涅槃重生", updateTime: "2026-07-22" },
      { id: 10, title: "第10话 巅峰对决", updateTime: "2026-07-28" },
      { id: 11, title: "第11话 武神降临", updateTime: "2026-08-03" },
    ],
    tags: ["热血", "武道", "逆袭", "战斗"],
  },
  {
    id: 3,
    title: "魔法学院的插班生",
    author: "星月琉璃",
    cover: "https://readdy.ai/api/search-image?query=A%20whimsical%20Chinese%20manhua%20cover%20of%20a%20magic%20academy%20student%20with%20sparkling%20magical%20effects%2C%20starry%20background%2C%20soft%20purple%20and%20silver%20tones%2C%20fantasy%20school%20uniform%2C%20cute%20and%20elegant%20art%20style%2C%20clean%20simple%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    category: "fantasy",
    description: "普通高中生苏小晚意外收到魔法学院的录取通知书，从此开启了奇幻的魔法之旅。会说话的猫、会飞的扫帚、神秘的图书馆……在这个充满魔法与奇迹的世界里，她发现了自己身世的惊天秘密。",
    rating: 9.3,
    views: 1890000,
    status: "连载中",
    updateTime: "2026-08-02",
    chapters: [
      { id: 1, title: "第1话 神秘的来信", updateTime: "2026-06-20" },
      { id: 2, title: "第2话 踏入魔法世界", updateTime: "2026-06-25" },
      { id: 3, title: "第3话 分院仪式", updateTime: "2026-06-30" },
      { id: 4, title: "第4话 第一节魔法课", updateTime: "2026-07-05" },
      { id: 5, title: "第5话 隐藏的天赋", updateTime: "2026-07-10" },
      { id: 6, title: "第6话 禁林冒险", updateTime: "2026-07-15" },
      { id: 7, title: "第7话 古老预言", updateTime: "2026-07-20" },
      { id: 8, title: "第8话 暗影逼近", updateTime: "2026-07-25" },
      { id: 9, title: "第9话 真相浮现", updateTime: "2026-08-02" },
    ],
    tags: ["奇幻", "魔法", "学院", "冒险"],
  },
  {
    id: 4,
    title: "女神驾到：校草别太拽",
    author: "甜心草莓酱",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20Chinese%20manhua%20cover%20with%20a%20fashionable%20schoolgirl%20and%20handsome%20schoolboy%20in%20modern%20campus%20setting%2C%20bright%20cherry%20blossom%20background%2C%20sweet%20pink%20and%20mint%20color%20palette%2C%20youthful%20romantic%20vibe%2C%20clean%20simple%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    category: "school",
    description: "转学第一天就惹上了全校最拽的校草？这运气也是没谁了！更离谱的是，这个高冷校草居然是她青梅竹马的邻居？校园里的甜蜜爆笑日常，看女神如何征服傲娇校草的心！",
    rating: 9.4,
    views: 2150000,
    status: "已完结",
    updateTime: "2026-07-30",
    chapters: [
      { id: 1, title: "第1话 转学生", updateTime: "2026-05-01" },
      { id: 2, title: "第2话 冤家路窄", updateTime: "2026-05-06" },
      { id: 3, title: "第3话 青梅竹马", updateTime: "2026-05-12" },
      { id: 4, title: "第4话 心跳的距离", updateTime: "2026-05-18" },
      { id: 5, title: "第5话 误会", updateTime: "2026-05-24" },
      { id: 6, title: "第6话 雨中告白", updateTime: "2026-05-30" },
      { id: 7, title: "第7话 牵手", updateTime: "2026-06-05" },
      { id: 8, title: "第8话 幸福终点", updateTime: "2026-06-12" },
    ],
    tags: ["校园", "恋爱", "搞笑", "甜宠"],
  },
  {
    id: 5,
    title: "深夜诡话",
    author: "暗夜行者",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20manhua%20cover%20with%20dark%20atmospheric%20horror%20theme%2C%20shadowy%20figure%20in%20fog%2C%20moonlit%20night%20scene%2C%20deep%20blue%20and%20silver%20tones%2C%20suspenseful%20mood%2C%20clean%20minimal%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    category: "horror",
    description: "每个深夜，城市角落都上演着不为人知的诡异故事。私家侦探陈墨接手一桩离奇失踪案，却意外揭开了一个隐藏在城市阴影中的惊天秘密。悬疑丛生，步步惊心，让你欲罢不能！",
    rating: 9.6,
    views: 1670000,
    status: "连载中",
    updateTime: "2026-08-01",
    chapters: [
      { id: 1, title: "第1话 失踪者", updateTime: "2026-06-10" },
      { id: 2, title: "第2话 线索", updateTime: "2026-06-15" },
      { id: 3, title: "第3话 目击者", updateTime: "2026-06-20" },
      { id: 4, title: "第4话 深夜追踪", updateTime: "2026-06-25" },
      { id: 5, title: "第5话 废弃工厂", updateTime: "2026-06-30" },
      { id: 6, title: "第6话 真相边缘", updateTime: "2026-07-06" },
      { id: 7, title: "第7话 幕后黑手", updateTime: "2026-07-12" },
      { id: 8, title: "第8话 绝地反击", updateTime: "2026-07-18" },
      { id: 9, title: "第9话 最后谜题", updateTime: "2026-07-25" },
      { id: 10, title: "第10话 黎明之前", updateTime: "2026-08-01" },
    ],
    tags: ["悬疑", "推理", "都市", "惊悚"],
  },
  {
    id: 6,
    title: "穿成反派的心尖宠",
    author: "云中仙",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20with%20ancient%20Chinese%20palace%20aesthetic%2C%20elegant%20female%20character%20in%20traditional%20hanfu%20dress%2C%20golden%20and%20jade%20green%20color%20scheme%2C%20historical%20fantasy%20romance%20theme%2C%20clean%20simple%20background%20with%20subtle%20cloud%20patterns%2C%20vertical%20format&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    category: "history",
    description: "一朝穿越，她成了小说里那个注定惨死的炮灰女配。为了活命，她决定抱紧反派大佬的大腿。谁知大腿抱得太紧，反派大佬居然对她动了真心？古风穿越甜宠，甜到牙疼！",
    rating: 9.5,
    views: 2340000,
    status: "连载中",
    updateTime: "2026-08-04",
    chapters: [
      { id: 1, title: "第1话 穿越", updateTime: "2026-05-20" },
      { id: 2, title: "第2话 初见反派", updateTime: "2026-05-25" },
      { id: 3, title: "第3话 抱大腿计划", updateTime: "2026-05-30" },
      { id: 4, title: "第4话 意外之吻", updateTime: "2026-06-04" },
      { id: 5, title: "第5话 他的偏爱", updateTime: "2026-06-10" },
      { id: 6, title: "第6话 危机四伏", updateTime: "2026-06-16" },
      { id: 7, title: "第7话 舍命相救", updateTime: "2026-06-22" },
      { id: 8, title: "第8话 情深不悔", updateTime: "2026-06-28" },
      { id: 9, title: "第9话 花烛之夜", updateTime: "2026-07-05" },
      { id: 10, title: "第10话 此生不负", updateTime: "2026-07-12" },
      { id: 11, title: "第11话 番外·日常", updateTime: "2026-07-20" },
      { id: 12, title: "第12话 番外·相守", updateTime: "2026-08-04" },
    ],
    tags: ["古风", "穿越", "甜宠", "宫斗"],
  },
  {
    id: 7,
    title: "银河远征队",
    author: "星际旅人",
    cover: "https://readdy.ai/api/search-image?query=A%20futuristic%20Chinese%20manhua%20cover%20with%20spaceship%20and%20astronaut%20characters%20in%20deep%20space%2C%20nebula%20background%2C%20cool%20blue%20and%20metallic%20silver%20color%20tones%2C%20sci-fi%20adventure%20theme%2C%20clean%20minimal%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    category: "scifi",
    description: "公元3024年，人类已经遍布银河系的各个角落。年轻的舰长陆星辰率领银河远征队，踏上探索未知星域的征程。外星文明、星际战争、宇宙奥秘……一场波澜壮阔的太空冒险即将展开！",
    rating: 9.2,
    views: 980000,
    status: "连载中",
    updateTime: "2026-07-31",
    chapters: [
      { id: 1, title: "第1话 启航", updateTime: "2026-06-01" },
      { id: 2, title: "第2话 虫洞跳跃", updateTime: "2026-06-07" },
      { id: 3, title: "第3话 未知信号", updateTime: "2026-06-13" },
      { id: 4, title: "第4话 第一类接触", updateTime: "2026-06-19" },
      { id: 5, title: "第5话 外星遗迹", updateTime: "2026-06-25" },
      { id: 6, title: "第6话 星际追击", updateTime: "2026-07-01" },
      { id: 7, title: "第7话 联盟与背叛", updateTime: "2026-07-08" },
      { id: 8, title: "第8话 终极武器", updateTime: "2026-07-15" },
      { id: 9, title: "第9话 银河之心", updateTime: "2026-07-23" },
      { id: 10, title: "第10话 新的征程", updateTime: "2026-07-31" },
    ],
    tags: ["科幻", "星际", "冒险", "机甲"],
  },
  {
    id: 8,
    title: "我的沙雕室友",
    author: "笑到肚子疼",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20manhua%20cover%20with%20comedic%20college%20roommate%20characters%20in%20hilarious%20situations%2C%20bright%20yellow%20and%20orange%20color%20palette%2C%20energetic%20and%20playful%20art%20style%2C%20comedy%20slice%20of%20life%20theme%2C%20clean%20simple%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    category: "comedy",
    description: "大学宿舍里住着四个性格迥异的男生：学霸、宅男、社交达人和运动狂人。他们的日常就是一部活生生的搞笑大片！从考试挂科到追女生翻车，从深夜卧谈到奇葩外卖，每一话都让你笑出腹肌！",
    rating: 9.1,
    views: 3120000,
    status: "连载中",
    updateTime: "2026-08-03",
    chapters: [
      { id: 1, title: "第1话 新生报到", updateTime: "2026-05-10" },
      { id: 2, title: "第2话 选课大战", updateTime: "2026-05-15" },
      { id: 3, title: "第3话 深夜泡面", updateTime: "2026-05-20" },
      { id: 4, title: "第4话 期末考试", updateTime: "2026-05-26" },
      { id: 5, title: "第5话 表白计划", updateTime: "2026-06-01" },
      { id: 6, title: "第6话 社团招新", updateTime: "2026-06-07" },
      { id: 7, title: "第7话 运动会", updateTime: "2026-06-13" },
      { id: 8, title: "第8话 寒假返乡", updateTime: "2026-06-20" },
      { id: 9, title: "第9话 新学期", updateTime: "2026-06-27" },
      { id: 10, title: "第10话 毕业季", updateTime: "2026-07-05" },
      { id: 11, title: "第11话 各奔东西", updateTime: "2026-07-15" },
      { id: 12, title: "第12话 再聚首", updateTime: "2026-08-03" },
    ],
    tags: ["搞笑", "校园", "日常", "治愈"],
  },
  {
    id: 9,
    title: "都市猎魔人",
    author: "夜不语",
    cover: "https://readdy.ai/api/search-image?query=A%20stylish%20Chinese%20manhua%20cover%20with%20modern%20urban%20demon%20hunter%20character%20in%20trench%20coat%2C%20neon%20city%20night%20background%2C%20dark%20red%20and%20black%20color%20scheme%2C%20supernatural%20action%20theme%2C%20clean%20minimal%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    category: "urban",
    description: "在繁华都市的表象之下，隐藏着常人无法看见的妖魔世界。猎魔人韩夜游走于城市暗处，以凡人之躯对抗超自然力量。当古老的封印开始松动，一场关乎人类存亡的战争悄然打响。",
    rating: 9.4,
    views: 1450000,
    status: "连载中",
    updateTime: "2026-07-29",
    chapters: [
      { id: 1, title: "第1话 深夜来电", updateTime: "2026-05-05" },
      { id: 2, title: "第2话 第一只魔", updateTime: "2026-05-11" },
      { id: 3, title: "第3话 猎魔人公会", updateTime: "2026-05-17" },
      { id: 4, title: "第4话 血色月光", updateTime: "2026-05-23" },
      { id: 5, title: "第5话 地下迷宫", updateTime: "2026-05-29" },
      { id: 6, title: "第6话 远古封印", updateTime: "2026-06-04" },
      { id: 7, title: "第7话 背叛者", updateTime: "2026-06-10" },
      { id: 8, title: "第8话 最终战役", updateTime: "2026-06-17" },
      { id: 9, title: "第9话 新世界", updateTime: "2026-06-24" },
    ],
    tags: ["都市", "猎魔", "战斗", "异能"],
  },
  {
    id: 10,
    title: "仙尊今天也在装萌新",
    author: "一叶知秋",
    cover: "https://readdy.ai/api/search-image?query=A%20humorous%20Chinese%20manhua%20cover%20with%20powerful%20immortal%20cultivator%20pretending%20to%20be%20a%20beginner%2C%20ancient%20Chinese%20cultivation%20world%20setting%2C%20golden%20and%20jade%20green%20colors%2C%20fantasy%20comedy%20theme%2C%20clean%20simple%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    category: "fantasy",
    description: "修仙界第一仙尊渡劫失败，重生到了现代都市。本想低调修炼，却因为实力太强频频被迫「装萌新」。当修真界的大佬们发现这个「萌新」其实是传说中的仙尊时，表情那叫一个精彩！",
    rating: 9.6,
    views: 1980000,
    status: "连载中",
    updateTime: "2026-08-02",
    chapters: [
      { id: 1, title: "第1话 渡劫失败", updateTime: "2026-06-01" },
      { id: 2, title: "第2话 重生都市", updateTime: "2026-06-06" },
      { id: 3, title: "第3话 一不小心就碾压", updateTime: "2026-06-11" },
      { id: 4, title: "第4话 收徒风波", updateTime: "2026-06-16" },
      { id: 5, title: "第5话 宗门来人", updateTime: "2026-06-22" },
      { id: 6, title: "第6话 身份暴露", updateTime: "2026-06-28" },
      { id: 7, title: "第7话 天下震动", updateTime: "2026-07-04" },
      { id: 8, title: "第8话 故人重逢", updateTime: "2026-07-10" },
      { id: 9, title: "第9话 幕后黑手", updateTime: "2026-07-17" },
      { id: 10, title: "第10话 仙尊归来", updateTime: "2026-07-24" },
      { id: 11, title: "第11话 新的传说", updateTime: "2026-08-02" },
    ],
    tags: ["修仙", "都市", "搞笑", "逆袭"],
  },
  {
    id: 11,
    title: "青梅不及天降",
    author: "糖心蛋",
    cover: "https://readdy.ai/api/search-image?query=A%20tender%20Chinese%20manhua%20cover%20showing%20a%20love%20triangle%20between%20childhood%20friend%20and%20new%20transfer%20student%2C%20school%20cherry%20blossom%20scene%2C%20soft%20pink%20and%20light%20blue%20tones%2C%20bittersweet%20romance%20theme%2C%20clean%20simple%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    category: "school",
    description: "从小到大，苏念一直默默喜欢着青梅竹马林逸。直到转学生顾言的出现，打破了这份平静。一个是陪伴多年的温柔青梅，一个是突然闯入的神秘天降，她的心该何去何从？",
    rating: 9.3,
    views: 1760000,
    status: "已完结",
    updateTime: "2026-07-15",
    chapters: [
      { id: 1, title: "第1话 青梅", updateTime: "2026-04-01" },
      { id: 2, title: "第2话 天降", updateTime: "2026-04-08" },
      { id: 3, title: "第3话 三人行", updateTime: "2026-04-15" },
      { id: 4, title: "第4话 心动的信号", updateTime: "2026-04-22" },
      { id: 5, title: "第5话 抉择", updateTime: "2026-04-29" },
      { id: 6, title: "第6话 告白", updateTime: "2026-05-06" },
      { id: 7, title: "第7话 答案", updateTime: "2026-05-13" },
    ],
    tags: ["校园", "恋爱", "青梅竹马", "三角恋"],
  },
  {
    id: 12,
    title: "绝世医妃",
    author: "柳如烟",
    cover: "https://readdy.ai/api/search-image?query=A%20gorgeous%20Chinese%20manhua%20cover%20with%20female%20doctor%20character%20in%20ancient%20palace%20setting%2C%20traditional%20Chinese%20medical%20elements%2C%20elegant%20red%20and%20gold%20color%20scheme%2C%20historical%20romance%20drama%20theme%2C%20clean%20simple%20composition%2C%20vertical%20format&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    category: "history",
    description: "现代医学博士穿越成古代相府庶女，凭借一手惊世医术在异世闯出一片天。治皇帝、救将军、斗权臣，顺便还把冷面王爷的心给偷了。医术在手，天下我有！",
    rating: 9.5,
    views: 2890000,
    status: "连载中",
    updateTime: "2026-08-04",
    chapters: [
      { id: 1, title: "第1话 穿越成庶女", updateTime: "2026-05-01" },
      { id: 2, title: "第2话 初露医术", updateTime: "2026-05-07" },
      { id: 3, title: "第3话 宫中风波", updateTime: "2026-05-13" },
      { id: 4, title: "第4话 冷面王爷", updateTime: "2026-05-19" },
      { id: 5, title: "第5话 瘟疫之战", updateTime: "2026-05-25" },
      { id: 6, title: "第6话 边境风云", updateTime: "2026-06-01" },
      { id: 7, title: "第7话 生死相随", updateTime: "2026-06-08" },
      { id: 8, title: "第8话 真相大白", updateTime: "2026-06-15" },
      { id: 9, title: "第9话 凤临天下", updateTime: "2026-06-23" },
      { id: 10, title: "第10话 盛世红妆", updateTime: "2026-07-01" },
    ],
    tags: ["古风", "穿越", "医术", "权谋"],
  },
];

export const bannerComics = [
  {
    id: 2,
    title: "武道巅峰",
    subtitle: "热血逆袭，登顶武道至尊",
    cover: "https://readdy.ai/api/search-image?query=A%20grand%20epic%20Chinese%20martial%20arts%20manhua%20banner%20with%20warrior%20silhouette%20against%20golden%20sunset%20sky%2C%20dramatic%20clouds%2C%20ancient%20Chinese%20landscape%2C%20warm%20golden%20and%20crimson%20tones%2C%20inspirational%20heroic%20atmosphere%2C%20cinematic%20composition%2C%20wide%20horizontal%20format&width=1600&height=600&seq=banner-01&orientation=landscape",
  },
  {
    id: 6,
    title: "穿成反派的心尖宠",
    subtitle: "古风穿越甜宠，甜到牙疼",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20ancient%20manhua%20banner%20with%20elegant%20couple%20in%20traditional%20hanfu%20under%20cherry%20blossom%20trees%2C%20palace%20in%20distance%2C%20soft%20pink%20and%20golden%20tones%2C%20dreamy%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=600&seq=banner-02&orientation=landscape",
  },
  {
    id: 8,
    title: "我的沙雕室友",
    subtitle: "笑出腹肌的校园日常",
    cover: "https://readdy.ai/api/search-image?query=A%20bright%20funny%20Chinese%20manhua%20banner%20with%20comedic%20college%20students%20in%20hilarious%20daily%20life%20situations%2C%20sunny%20campus%20background%2C%20vibrant%20yellow%20and%20orange%20tones%2C%20energetic%20happy%20atmosphere%2C%20cinematic%20wide%20composition&width=1600&height=600&seq=banner-03&orientation=landscape",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20male%20avatar%20with%20glasses%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20professional%20style%2C%20square%20composition&width=120&height=120&seq=avatar-01&orientation=squarish",
    content: "羞羞歪歪漫画真的是我每天必刷的平台！更新速度超快，画质清晰，最重要的是全免费！竖屏阅读体验太爽了，躺着看漫画简直不要太舒服。",
    rating: 5,
    date: "2026-07-28",
  },
  {
    id: 2,
    name: "甜甜的草莓糖",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20female%20avatar%20with%20long%20hair%2C%20sweet%20smile%2C%20simple%20warm%20background%2C%20clean%20cute%20style%2C%20square%20composition&width=120&height=120&seq=avatar-02&orientation=squarish",
    content: "恋爱漫画爱好者狂喜！这里的恋爱漫画种类超全，从校园到古风，每一部都画风精美。而且没有广告打扰，阅读体验一流，已经推荐给所有闺蜜了！",
    rating: 5,
    date: "2026-07-25",
  },
  {
    id: 3,
    name: "热血漫迷",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20male%20avatar%20with%20cool%20style%2C%20confident%20expression%2C%20simple%20warm%20background%2C%20clean%20modern%20style%2C%20square%20composition&width=120&height=120&seq=avatar-03&orientation=squarish",
    content: "作为热血漫的狂热粉丝，羞羞歪歪漫画的武道巅峰简直是我的心头好！画风炸裂，剧情燃到爆！而且每天都更新，完全停不下来。强烈推荐给所有喜欢热血战斗的朋友！",
    rating: 5,
    date: "2026-07-20",
  },
  {
    id: 4,
    name: "夜猫子小姐",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20female%20avatar%20with%20stylish%20look%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20clean%20elegant%20style%2C%20square%20composition&width=120&height=120&seq=avatar-04&orientation=squarish",
    content: "深夜追漫党表示这个平台太友好了！下拉式阅读方便到不行，躺着看、坐着看、趴着看都OK。而且全部章节无删减，这才是真正的良心平台！",
    rating: 5,
    date: "2026-07-18",
  },
];